import type { SegmentEvent } from '@segment/analytics-next'
import { redactUrlSecrets } from 'lib/helpers/redactUrlSecrets/redactUrlSecrets'

interface RedactSegmentPayloadParams {
  event: SegmentEvent
}

const PAGE_URL_FIELDS = ['url', 'path', 'search', 'referrer'] as const

const redactPageFields = (fields: Record<string, unknown>) => {
  PAGE_URL_FIELDS.forEach((name) => {
    const value = fields[name]

    if (typeof value === 'string') {
      fields[name] = redactUrlSecrets({ url: value })
    }
  })
}

/** analytics.js copies `context.page` into `properties` on page calls, so both are redacted. */
export const redactSegmentPayload = ({ event }: RedactSegmentPayloadParams): void => {
  if (event.context?.page) {
    redactPageFields(event.context.page)
  }

  if (event.type === 'page' && event.properties) {
    redactPageFields(event.properties)
  }
}
